import cx from 'classnames';
import Image from 'next/image';

import { useTrackEventAmplitude } from '../../../../../core/Tracking/Amplitude/Amplitude';
import { Button } from '../../../../../design-system/components/form/button/Button';
import { Typography } from '../../../../../design-system/components/typography/Typography';
import { HighlightTextBlockSliceType } from '../../../../../domains/Prismic/BrandPages/BrandPagesDocument';
import { EvaneosPrismicRichText } from '../../../../../domains/Prismic/EvaneosPrismicRichText';

import style from './HighlightTextBlockSlice.module.css';

export type HighlightTextBlockSliceProps = HighlightTextBlockSliceType;

export function HighlightTextBlockSlice({
    version,
    picture,
    title,
    text,
    ctaLabel,
    ctaLink,
    sliceIndex,
    target,
}: HighlightTextBlockSliceProps & { sliceIndex?: number }) {
    const { trackEvent } = useTrackEventAmplitude();
    return (
        <div className={style.wrapper}>
            {picture?.url ? (
                <Image
                    className={style.image}
                    alt={picture.alt}
                    src={picture.url}
                    unoptimized
                    fill
                    priority
                />
            ) : null}
            <div
                className={cx(style.content, {
                    backgroundGreen: version === 'green',
                    backgroundYellow: version === 'yellow',
                    backgroundWhite: version === 'white',
                })}
            >
                {title ? (
                    <Typography as="p" scale="primary-m-extra-bold" className={style.title}>
                        {title}
                    </Typography>
                ) : null}

                {text ? <EvaneosPrismicRichText field={text} /> : null}

                {ctaLabel && ctaLink?.url ? (
                    <div>
                        <Button
                            priority="text"
                            reversed={version === 'green'}
                            href={ctaLink.url}
                            target={target || undefined}
                            onClick={() => {
                                trackEvent((ampli, defaultProperties) => {
                                    ampli.highlightTextBoxClicked({
                                        ...defaultProperties,
                                        block_index: sliceIndex ? sliceIndex + 1 : 0,
                                        block_title: title ?? undefined,
                                    });
                                });
                            }}
                        >
                            {ctaLabel}
                        </Button>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
